/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  ContentImportRun,
  ContentImportSource,
  ContentImportTarget,
  EntityId,
  List,
} from "./data-contracts";

/**
 * @description Returns the import runs of the organization, most recent first. Runs left behind by an import that never reported back are returned as failed.
 * @tags imports
 * @name ListImportRuns
 * @summary List the import runs of an organization
 * @request GET:/org/{organizationId}/imports
 * @secure
 */

// @ts-ignore
export const listImportRuns: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {
    /** Only return the import runs targeting this space. */
    space?: string;
    /** Only return the import runs targeting this change request. */
    changeRequest?: string;
    /** Only return the import runs targeting a space of this site. */
    site?: string;
    /** Only return the import runs in this status. `active` covers both `pending` and `in-progress`. */
    status?:
      | "active"
      | "pending"
      | "in-progress"
      | "completed"
      | "failed"
      | "cancelled";
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: ContentImportRun[];
  };
  ResponseStatusCode: 200 | 404;
} = {
  route: "/org/{organizationId}/imports",
  method: "get",
  streaming: false,
  tags: ["imports"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags imports
 * @name StartImportRun
 * @summary Import content into a space from a website
 * @request POST:/org/{organizationId}/imports
 * @secure
 */

// @ts-ignore
export const startImportRun: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: {
    source: ContentImportSource;
    target: ContentImportTarget;
    /** ID of the site the import is for, to list it among that site's imports. Only needed when the target space does not belong to the site yet — a site being set up, whose space is attached once the import has started. Otherwise the site is resolved from the space. */
    site?: string;
    /**
     * Enhance the imported content with AI
     * @default true
     */
    enhance?: boolean;
  };
  RequestHeaders: {};
  ResponseBody: ContentImportRun;
  ResponseStatusCode: 201 | 400 | 404;
} = {
  route: "/org/{organizationId}/imports",
  method: "post",
  streaming: false,
  tags: ["imports"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns the import run. A run left behind by an import that never reported back is returned as failed.
 * @tags imports
 * @name GetImportRun
 * @summary Get an import run
 * @request GET:/org/{organizationId}/imports/{importRunId}
 * @secure
 */

// @ts-ignore
export const getImportRun: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the import run */
    importRunId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: ContentImportRun;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/org/{organizationId}/imports/{importRunId}",
  method: "get",
  streaming: false,
  tags: ["imports"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags imports
 * @name CancelImportRun
 * @summary Cancel an import run
 * @request POST:/org/{organizationId}/imports/{importRunId}/cancel
 * @secure
 */

// @ts-ignore
export const cancelImportRun: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the import run */
    importRunId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: ContentImportRun;
  ResponseStatusCode: 200 | 400 | 404;
} = {
  route: "/org/{organizationId}/imports/{importRunId}/cancel",
  method: "post",
  streaming: false,
  tags: ["imports"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
